import React, {useState, useEffect } from "react";

export default function CSStest(props) {
  const correctAnswers = [1, 2, 2, 1, 0, 0, 1, 0, 0, 0, 1, 1, 1, 1, 1, 0, 1, 0, 0, 0, 1, 1, 1, 1, 0];
  const que = {
    q1: {
      string: "1. Which property is used to change the background color?",
      options: ["color", "background-color", "bgcolor", "background"],
      ans: 1
    },
    q2: {
      string: "2. Which property is used to change the text color of an element?",
      options: ["fgcolor", "text-color", "color", "font-color"],
      ans: 2
    },
    q3: {
      string: "3. Which property is used to change the font of an element?",
      options: ["font-style", "font-weight", "font-family", "font-text"],
      ans: 2
    },
    q4: {
      string: "4. Which property controls the size of text?",
      options: ["text-size", "font-size", "text-style", "font-style"],
      ans: 1
    },
    q5: {
      string: "5. How do you select an element with id 'demo'?",
      options: ["#demo", ".demo", "demo", "element#demo"],
      ans: 0
    },
    q6: {
      string: "6. How do you select elements with class name 'example'?",
      options: [".example", "#example", "example", "element.example"],
      ans: 0
    },
    q7: {
      string: "7. Which property is used to change the left margin of an element?",
      options: ["padding-left", "margin-left", "indent-left", "space-left"],
      ans: 1
    },
    q8: {
      string: "8. Which CSS property is used to change the text alignment of an element?",
      options: ["text-align", "vertical-align", "align-text", "text-justify"],
      ans: 0
    },
    q9: {
      string: "9. How do you make the text bold?",
      options: ["font-weight:bold;", "style:bold;", "font:bold;", "font:bold-weight;"],
      ans: 0
    },
    q10: {
      string: "10. Which property is used to change the space between letters?",
      options: ["letter-spacing", "text-spacing", "character-spacing", "font-spacing"],
      ans: 0
    },
    q11: {
      string: "11. Which property is used to change the bottom border of an element?",
      options: ["border-width", "border-bottom", "bottom-border", "border-style"],
      ans: 1
    },
    q12: {
      string: "12. Which property is used to create space between the element's border and inner content?",
      options: ["margin", "padding", "spacing", "border-spacing"],
      ans: 1
    },
    q13: {
      string: "13. How do you add a background image to an element?",
      options: ["background-color:url(image.jpg);", "background-image:url(image.jpg);", "background:url(image.jpg);", "image:url(image.jpg);"],
      ans: 1
    },
    q14: {
      string: "14. Which property is used to change the style of the bottom border?",
      options: ["border-style", "border-bottom-style", "border-bottom", "border-bottom-type"],
      ans: 1
    },
    q15: {
      string: "15. How do you change the list style to show squares instead of bullets?",
      options: ["list-type:square;", "list-style-type:square;", "list-square:square;", "list-style:square;"],
      ans: 1
    },
    q16: {
      string: "16. Which property is used to set the width of an element?",
      options: ["width", "element-width", "size-width", "block-width"],
      ans: 0
    },
    q17: {
      string: "17. Which CSS property is used to change the style of the text?",
      options: ["text-style", "font-style", "text-decoration", "font-decoration"],
      ans: 1
    },
    q18: {
      string: "18. How do you make each word in a text start with a capital letter?",
      options: ["text-transform:capitalize;", "text-style:capitalize;", "font-transform:capitalize;", "transform:capitalize;"],
      ans: 0
    },
    q19: {
      string: "19. How do you select all p elements inside a div element?",
      options: ["div p", "div.p", "p div", "div#p"],
      ans: 0
    },
    q20: {
      string: "20. How do you group multiple selectors?",
      options: ["Separate each selector with a space", "Separate each selector with a comma", "Separate each selector with a plus sign", "Separate each selector with a dot"],
      ans: 1
    },
    q21: {
      string: "21. Which property is used to change the font size of an element?",
      options: ["text-size", "font-size", "font-height", "text-height"],
      ans: 1
    },
    q22: {
      string: "22. Which value is used to hide an element but still take up space in the layout?",
      options: ["display:none;", "visibility:hidden;", "opacity:0;", "hide:true;"],
      ans: 1
    },
    q23: {
      string: "23. How do you make the text italic?",
      options: ["font:italic;", "font-style:italic;", "text-italic;", "text-style:italic;"],
      ans: 1
    },
    q24: {
      string: "24. Which property is used to change the top margin of an element?",
      options: ["padding-top", "margin-top", "space-top", "top-margin"],
      ans: 1
    },
    q25: {
      string: "25. How do you change the color of a hyperlink when the user hovers over it?",
      options: ["a:hover {color: red;}", "a:hover {text-color: red;}", "a:hover {font-color: red;}", "a:hover {hover-color: red;}"],
      ans: 0
    }
  };


  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1>CSS <span>Skill</span> Test</h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1> 
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
          <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
